import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-full max-h-full flex-col" }
const _hoisted_2 = { class: "pr-2" }
const _hoisted_3 = { class: "flex h-full flex-col gap-2 overflow-y-scroll p-2.5 pt-0" }

import { Ref, onBeforeUnmount, ref, watch } from 'vue';
import { RouteLocationNormalizedLoaded, Router, useRoute, useRouter } from 'vue-router';
import { getFirstElement } from '@blackdesertmarket/helpers';
import { BlackDesertItem, BlackDesertItemType } from '@blackdesertmarket/interfaces';
import { isValidBlackDesertItemType } from '@blackdesertmarket/objects';
import { ListFilterData } from '@/interfaces/list-filter';
import { LoaderSize } from '@/enums/loader';
import { useLocationStore } from '@/stores/location';
import { UseItemTypeReturn, useItemType } from '@/composables/item-type/use-item-type';
import { UseItemTypeFetchReturn, useItemTypeFetch } from '@/composables/item-type/use-item-type-fetch';
import { UseListFilterReturn, useListFilter } from '@/composables/list-filter/use-list-filter';
import { TranslateKey, useInject } from '@/composables/use-inject';
import AppLoader from '@/components/Base/AppLoader/AppLoader.vue';
import { ListFilterExposed } from '@/components/ListFilter/ListFilter.d';
import ListFilter from '@/components/ListFilter/ListFilter.vue';
import ListFilterButton from '@/components/ListFilter/ListFilterButton.vue';
import ListFilterButtonContent from '@/components/ListFilter/ListFilterButtonContent.vue';
import ListItem from '@/components/ListItem/ListItem.vue';
import ListItemProperty from '@/components/ListItem/ListItemProperty.vue';
import ListItemSeparator from '@/components/ListItem/ListItemSeparator.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemTypeList',
  props: {
  id: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const translate = useInject(TranslateKey);
const locationStore = useLocationStore();
const router: Router = useRouter();
const route: RouteLocationNormalizedLoaded = useRoute();

const loaded: Ref<boolean> = ref(false);
const search: Ref<boolean> = ref(false);
const itemList: Ref<BlackDesertItem[] | BlackDesertItemType[]> = ref([]);
const itemType: Ref<BlackDesertItemType | null> = ref(null);
const listFilter: Ref<ListFilterExposed | null> = ref(null);

const getListItemKey = (item: BlackDesertItem | BlackDesertItemType): string => {
  return isValidBlackDesertItemType(item) ? `${item.id}.${item.enhancement}` : `${item.id}`;
};

const getTradeCount = (itemType: BlackDesertItemType): string => {
  const itemTypeComposable: UseItemTypeReturn = useItemType(itemType);
  return itemTypeComposable.getTradeCount();
};

const refetchItemTypeList = (id: number): Promise<void> => {
  const itemTypeFetch: UseItemTypeFetchReturn = useItemTypeFetch(id);

  return itemTypeFetch.fetch().then((data: BlackDesertItemType[]): void => {
    itemType.value = Object.assign({}, getFirstElement<BlackDesertItemType>(data));

    if (itemType.value) {
      const itemTypeComposable: UseItemTypeReturn = useItemType(itemType.value);
      itemTypeComposable.aggregateItemByList(data);

      locationStore.mainCategory = itemType.value.mainCategory;
      locationStore.subCategory = itemType.value.subCategory;
      locationStore.searchWord = itemType.value.name;
    }

    itemList.value = data;
    loaded.value = true;
  });
};

const redirectItemTypeList = (): void => {
  loaded.value = false;
  refetchItemTypeList(props.id);

  if (listFilter.value) {
    listFilter.value.resetFilterState();
  }
};

const handleListItemClick = (item: BlackDesertItem | BlackDesertItemType): void => {
  if (isValidBlackDesertItemType(item)) {
    router.push({
      name: 'item-details',
      params: {
        id: item.id,
        enhancement: item.enhancement,
      },
    });

    return;
  }

  if (props.id === item.id) {
    redirectItemTypeList();
    return;
  }

  router.push({
    name: 'item',
    params: {
      id: item.id,
    },
  });
};

const handleListFilter = async (data: ListFilterData): Promise<void> => {
  const listFilter: UseListFilterReturn = useListFilter(data);

  await listFilter.processItemList({
    itemList: itemList,
    loaded: loaded,
    fallback(): Promise<void> {
      return refetchItemTypeList(props.id).then((): void => {
        search.value = false;
      });
    },
    callback(): void {
      search.value = true;
    },
  });
};

const handleListFilterButtonClick = (): void => {
  if (!itemType.value) {
    return;
  }

  router.push({
    name: 'list',
    params: {
      mainCategory: itemType.value.mainCategory,
      subCategory: itemType.value.subCategory,
    },
  });
};

if (!itemList.value.length) {
  refetchItemTypeList(props.id);
}

onBeforeUnmount((): void => {
  if (route.name === 'list') {
    return;
  }

  locationStore.mainCategory = null;
  locationStore.subCategory = null;
  locationStore.searchWord = '';
});

watch(
  (): number => {
    return props.id;
  },
  (): void => {
    redirectItemTypeList();
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ListFilter, {
        ref_key: "listFilter",
        ref: listFilter,
        onFilter: handleListFilter
      }, _createSlots({ _: 2 }, [
        (!search.value)
          ? {
              name: "bottom",
              fn: _withCtx(() => [
                _createVNode(ListFilterButton, { onClick: handleListFilterButtonClick }, {
                  default: _withCtx(() => [
                    _createVNode(ListFilterButtonContent, {
                      icon: require('@/assets/images/list-filter/return.png')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(translate)('listFilter.previous')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              key: "0"
            }
          : undefined
      ]), 1536),
      _createElementVNode("div", _hoisted_3, [
        (!search.value && itemType.value)
          ? (_openBlock(), _createBlock(ListItem, {
              key: 0,
              item: itemType.value,
              disabled: "",
              class: "bg-gradient-to-b from-brand-600/60 to-brand-300/80"
            }, {
              append: _withCtx(() => [
                _createVNode(ListItemSeparator),
                _createVNode(ListItemProperty, {
                  label: _unref(translate)('itemType.tradeCount'),
                  value: getTradeCount(itemType.value)
                }, null, 8, ["label", "value"]),
                _createVNode(ListItemSeparator),
                _createVNode(ListItemProperty, {
                  label: _unref(translate)('item.count'),
                  value: itemType.value.count
                }, null, 8, ["label", "value"])
              ]),
              _: 1
            }, 8, ["item"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList.value, (item) => {
          return (_openBlock(), _createBlock(ListItem, {
            key: getListItemKey(item),
            item: item,
            onEffect: ($event: any) => (handleListItemClick(item))
          }, null, 8, ["item", "onEffect"]))
        }), 128))
      ])
    ]),
    (!loaded.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          size: _unref(LoaderSize).LARGE,
          overlay: ""
        }, null, 8, ["size"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})